/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */
import dayjs from "dayjs";
import { CmsConfig } from "cms/config";
import { getPrimaryDate, hasPrimaryDate } from "cms/model/helpers";
import { NewsItemImage } from "../news-item-image";

const ResultItemNews = (props) => {

    const model = props?.model;
    const description = model?.description;
    const path = model?.path;
    const title = model?.title;

    const hasDate = hasPrimaryDate(model);
    let primary_date;
    if (hasDate) {
        const dateData = getPrimaryDate(model);
        const date = dateData?.date;
        primary_date = date ? dayjs(date).format(CmsConfig.dates.display.date_fullday) : undefined;
    }

    return (
        <div className="feed-result-row news-item">
            <NewsItemImage model={model} />
            <div className='news-item-content'>
                <h3 className="title">
                    <a href={path}>{title}</a>
                </h3>
                {primary_date && <div className="field field-name-post-date">Posted on {primary_date}</div>}
                <div className="feed-result-description">
                    <p>{description}</p>
                </div>
            </div>
        </div>
    );
};

export { ResultItemNews };
